import axios from "axios";

export default {
	loadRaw(params = '', token) {
		let http = axios.create({
		  baseURL: process.env.VUE_APP_API_MOBILE_URL,
		  headers: {
		    Authorization: "bearer " + token,
		  },
		});

		return http.get('v2/produtos/dashboard' + params)
	},
}
